exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/personal-cabinet/personal-cabinet.component.scss
// module id = ../../../../../src/app/personal-cabinet/personal-cabinet.component.scss
// module chunks = 0